const SHEET_CLOSE_MS = 380;

export { SHEET_CLOSE_MS };
